<template>
  <el-form
    class="form-tag"
    ref="vmlistImageOften"
    :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
  >
    <el-row :gutter="5" :key="index" v-for="(item, index) in listImageOften">
      <el-col
        :span="4"
        v-for="(Image, i) in item"
        :key="Image._id"
        class="uk-text-center word-break"
      >
        <span
          @click="fnSendImageOftenToLine(Image.link)"
          v-show="fnCheckShowFile(Image.link) == true"
        >
          <img :src="Image.link" class="ui-path-img" />
        </span>
        <span
          @click="fnSendImageOftenToLine(Image.link)"
          v-show="fnCheckShowFile(Image.link) == false"
        >
          <img
            src="https://chat.mushroomtravel.com/storage-dev/14368/668eee00-3e6a-11ea-bd60-652740535233.png"
            class="ui-path-img"
          />
          <strong v-nameFile="Image.link" class="uk-text-bold"></strong>
        </span>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { Form, Row, Col } from 'element-ui';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      listImageOften: [],
    };
  },
  computed: {
    ...mapGetters('chat', ['sickersAndOftenImage']),
  },
  components: {
    [Form.name]: Form,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  directives: {
    nameFile: {
      bind: function(el, binding) {
        if (binding.value) {
          const name = binding.value
            .substring(binding.value.lastIndexOf('/'))
            .replace('/', '');
          el.innerHTML = name;
        }
      },
    },
  },
  methods: {
    fnSendImageOftenToLine(url) {
      var allowedExtension = ['.jpeg', '.jpg', '.png', '.gif', '.bmp'];
      const type = url.substring(url.lastIndexOf('.'));
      var isNotImage = _.filter(allowedExtension, function(v) {
        return type.indexOf(v) != -1;
      });
      var typeSendUrl = '';
      if (isNotImage.length == 0) {
        typeSendUrl = 'url';
      } else {
        typeSendUrl = 'image';
      }
      this.$emit('send-imageOften-line', url, typeSendUrl);
    },
    fnCheckShowFile(value) {
      var allowedExtension = ['.jpeg', '.jpg', '.png', '.gif', '.bmp'];
      const type = value.substring(value.lastIndexOf('.'));
      var isNotImage = _.filter(allowedExtension, function(v) {
        return type.indexOf(v) != -1;
      });
      if (isNotImage.length == 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  created() {
    if (this.sickersAndOftenImage.length == 0) {
      this.$store.dispatch('chat/loadSickerandfile').then(value => {
        if (value.length > 0) {
          this.listImageOften = _.chunk(
            _.filter(this.sickersAndOftenImage, function(v) {
              return v.type == 'favorite';
            }),
            6,
          );
        }
      });
    } else {
      this.listImageOften = _.chunk(
        _.filter(this.sickersAndOftenImage, function(v) {
          return v.type == 'favorite';
        }),
        6,
      );
    }
  },
};
</script>

<style scoped>
.el-form.form-tag .el-row .el-col span {
  cursor: pointer;
}
.word-break {
  overflow: hidden;
  word-break: break-word;
}
.el-form.form-tag.on-mobile {
  position: absolute;
  width: 100%;
  z-index: 3000;
  bottom: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageOften.vue